import React, { useState } from "react";
import "./Project.css";

function Project({ image, name, linkToProject }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`project`}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => window.open(linkToProject, "_blank")}
    >
      <img
        src={image}
        alt={name}
        className={hovered && "project__hoveredImage"}
      />
      <p className={hovered && "project__hoveredName"}>{name}</p>
    </div>
  );
}

export default Project;
